module.exports = __webpack_public_path__ + "img/sam-bucket-hat-01.93373866.jpg";